import { uploadTemplate } from '../../api/models/assets';
import { FORM_DATATYPES, TpAutoFormDef, promptAutoForm } from '../auto-form-modal/AutoForm';
import { createFastQPairs, getFastQTable, promptModifyFastQForm } from './Fastq';

export enum UPLOAD_TYPES {
  FASTQSAMPLESET = 'fastqSampleSet',
}

export const uploadTypeToAllowedExtensions = {
  [UPLOAD_TYPES.FASTQSAMPLESET]: ['.fastq.gz'],
};

export interface FastqMetadata {
  fileName: string;
  read: string;
  lane: string;
  sampleId: string;
}

export interface UploadFile extends Blob {
  lastModified: number;
  name: string;
  size: number;
  fileType?: string;
  metadata?: FastqMetadata; // this can be extended to any type of property e.g. csvMetaData, etc.
}

export const fileMatchesPattern = (fileName: string, selectedTemplate: any) => {
  for (const propertyPattern of selectedTemplate.filePatterns) {
    for (const pattern of propertyPattern.patterns) {
      if (fileName.match(pattern)) {
        return true;
      }
    }
  }
  return false;
};

export const CreateFileSetAssets = (selectedTemplate: any, fileSet: UploadFile[]) => {
  if (selectedTemplate.uploadType === UPLOAD_TYPES.FASTQSAMPLESET) {
    if (fileSet.length > 0) {
      const tempPairs = createFastQPairs(fileSet, selectedTemplate.filePatterns);
      for (const [key, value] of Object.entries(tempPairs)) {
        for (const property of selectedTemplate.fileSetMetadata) {
          if (!value[property.id]) {
            value[property.id] = '';
          }
        }
      }
      return tempPairs;
    }
  }
};

export const getTable = (
  fileSetAssets: any,
  selectedTemplate: uploadTemplate,
  setFileSetAssets: (newValue: any) => void,
  onRowClick: (row: any) => void,
  ValidationCheck,
) => {
  if (selectedTemplate.uploadType === UPLOAD_TYPES.FASTQSAMPLESET) {
    return getFastQTable(fileSetAssets, selectedTemplate, setFileSetAssets, onRowClick, ValidationCheck);
  }
};

export const promptModifyFileRow = (fileSetTypeName: string, rowEntry: any, selectedTemplate: uploadTemplate) => {
  if (selectedTemplate.uploadType === UPLOAD_TYPES.FASTQSAMPLESET) {
    return promptModifyFastQForm(fileSetTypeName, rowEntry, selectedTemplate);
  } else {
    return Promise.resolve(undefined);
  }
};

export function promptRenameFile(fileObj: UploadFile, selectedTemplate: any): Promise<UploadFile> {
  const form: TpAutoFormDef = {
    title: `Filename ${fileObj.name} could not be matched to any file pattern. Please rename the file.`,
    fields: [
      {
        id: 'fileName',
        name: 'New File Name',
        dataType: FORM_DATATYPES.STRING,
        startContent: fileObj.name,
        required: true,
        inputValidation: (content) => {
          return fileMatchesPattern(content, selectedTemplate);
        },
        ValidationMessage: 'Please make sure to match any of the existing file patterns.',
      },
    ],
  };
  return promptAutoForm(form).then((dataForm: any) => {
    const renamedFile: UploadFile = new File([fileObj], dataForm.fileName, { type: fileObj.type });
    return renamedFile;
  });
}

export function getFileAssetType(selectedTemplate: any) {
  if (selectedTemplate.uploadType === UPLOAD_TYPES.FASTQSAMPLESET) {
    return 'fastq';
  }
  return '';
}
